import AlertCircleIcon from 'assets/ver2/icons/alert-circle-icon.svg';
import CameraAddIcon from 'assets/ver2/icons/camera-add-icon.svg';
import ButtonCommon from 'components/common/ButtonCommon';
import SizeBox from 'components/common/SizeBox';
import useProfile from 'features/profile2.0/hooks/useProfile';
import VerificationUploadDocumentsDrawer from 'features/uploadDocuments/components/VerificationUploadDocumentsDrawer';
import useDrawer from 'hooks/useDrawer';
import useLang from 'hooks/useLang';
import React from 'react';
import styled from 'styled-components';
import {
  displayFlexRowCenterStartMixin,
  fontSize14Mixin,
  paragraph500Mixin,
  paragraph700Mixin,
  textBreakLineWordMixin,
} from 'styles';

const VerificationRequiresPhotos = () => {
  const { t } = useLang();

  const { isProfileStatusPendingDocuments } = useProfile();

  const { renderDrawerComponent } = useDrawer({
    drawer: ({ drawerRef, handleOnToggleNavbar }) => (
      <VerificationUploadDocumentsDrawer
        ref={drawerRef}
        NavBarToggle={
          <ButtonCommon
            value={t('button_upload_documents')}
            color="var(--ds-c-blue)"
            background="var(--ds-c-white)"
            isFill={false}
            styles={{
              paddingInline: '0',
            }}
            buttonIconStyles={{
              gap: '4px',
              paddingInline: '16px',
              height: '50px',
            }}
            borderNameVariable="--border-filter"
            iconSrc={CameraAddIcon}
          />
        }
        onClose={handleOnToggleNavbar}
      />
    ),
  });

  if (!isProfileStatusPendingDocuments) return null;
  return (
    <>
      <VerificationRequiresPhotosStyled>
        <Title>
          {t('label_verification')}
          <img src={AlertCircleIcon} width={20} height={20} />
        </Title>
        <SizeBox height={10} />
        <Desc
          dangerouslySetInnerHTML={{
            __html: t('profile_verification_requires_photos_desc'),
          }}
        />
        <SizeBox height={10} />
        {renderDrawerComponent()}
      </VerificationRequiresPhotosStyled>
      <SizeBox height={20} />
    </>
  );
};

const VerificationRequiresPhotosStyled = styled.div`
  width: 100%;
  height: fit-content;
  padding: 10px;
  border-radius: 10px;
  background-color: #f6f6f6;
`;

const Title = styled.p`
  ${paragraph700Mixin};
  text-transform: uppercase;
  color: #0e1012;
  ${displayFlexRowCenterStartMixin};
  gap: 4px;
`;

const Desc = styled.p`
  ${paragraph500Mixin};
  ${fontSize14Mixin};
  ${textBreakLineWordMixin};
`;

export default VerificationRequiresPhotos;
